export const Logo = ({ light = false }) => {
  const tone = light ? "white" : "dark";
  if (light) {
    return (
      <a href="/" data-testid="footer-logo-link" className="inline-block">
        <img src="/brand/logo-white.png" width="303" height="159" alt="Bedsolving Indonesia — Villas and Accomodation" className="h-24 w-auto" />
      </a>
    );
  }
  return (
    <a href="/" data-testid="logo-link" className="flex shrink-0 items-center gap-3">
      <img src={`/brand/mark-${tone}.png`} width="89" height="98" alt="" aria-hidden="true" className="h-10 w-auto" />
      <img src={`/brand/wordmark-${tone}.png`} width="303" height="36" alt="Bedsolving Indonesia" className="h-6 w-auto sm:h-7" />
    </a>
  );
};
